/**
 * Utilidades para WebRTC y manejo de permisos de micrófono
 */

/**
 * Verificar si WebRTC está disponible
 */
export function isWebRTCAvailable() {
  return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
}

/**
 * Verificar si estamos en HTTPS o localhost
 */
export function isSecureContext() {
  return window.location.protocol === 'https:' || 
         window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1';
}

/**
 * Solicitar permisos de micrófono de forma segura
 */
export async function requestMicrophonePermission() {
  // Verificar si WebRTC está disponible
  if (!isWebRTCAvailable()) {
    const protocol = window.location.protocol;
    const message = protocol === 'http:' 
      ? 'WebRTC requiere HTTPS para acceder al micrófono. Continuando en modo de desarrollo.'
      : 'WebRTC no está disponible en este navegador.';
    
    console.warn(message);
    return {
      success: false,
      message: message,
      canContinue: protocol === 'http:' // Permitir continuar en HTTP para desarrollo
    };
  }

  try {
    await navigator.mediaDevices.getUserMedia({ audio: true });
    return {
      success: true,
      message: 'Permisos de micrófono concedidos',
      canContinue: true
    };
  } catch (error) {
    let message = 'Error desconocido';
    
    switch (error.name) {
      case 'NotAllowedError':
        message = 'Permisos de micrófono denegados. Por favor, permite el acceso al micrófono.';
        break;
      case 'NotFoundError':
        message = 'No se encontró ningún micrófono en el dispositivo.';
        break;
      case 'NotReadableError':
        message = 'El micrófono está siendo usado por otra aplicación.';
        break;
      case 'OverconstrainedError':
        message = 'Las restricciones de audio no se pueden satisfacer.';
        break;
      case 'SecurityError':
        message = 'Error de seguridad al acceder al micrófono.';
        break;
      default:
        message = `Error al acceder al micrófono: ${error.message}`;
    }

    return {
      success: false,
      message: message,
      canContinue: false,
      error: error
    };
  }
}

/**
 * Obtener información del contexto WebRTC
 */
export function getWebRTCInfo() {
  return {
    isAvailable: isWebRTCAvailable(),
    isSecure: isSecureContext(),
    protocol: window.location.protocol,
    hostname: window.location.hostname,
    userAgent: navigator.userAgent
  };
}
